FAQAutoSuggestionListView = require('./autosuggestionlist')

class  FAQV1AutoSuggestionListView extends FAQAutoSuggestionListView

  initialize: ->
    FAQAutoSuggestionListView::initialize.apply(this, arguments)

  renderNoSuggestions: (keyword, status) ->
    Groupon.FAQ.ViewManager.renderErrorHtml({
      container : @errorContainer
      query : keyword
      errorHtmlText : "<div data-bhw='faq___#{encodeURIComponent(keyword)}___no-results-displayed-for-autocomplete-api-#{status}' class='noResults'>#{I18n.t('js.modules.faq.not_found')}</div>"
    })

  renderSuggestions: (response) ->
    @renderBreadCrumbs(response.query, "#{I18n.t('js.modules.faq.search_result')}'#{response.query}'")
    if response?.docs?.length > 0
      @toHtml()
      @renderSuggestionElements(response)
    else
      @renderNoSuggestions(response.query, 'success')

module.exports = FAQV1AutoSuggestionListView
